import { Component } from "@angular/core";

@Component({
  selector: "app-q-card-seconary-text",
  templateUrl: "./q-card-seconary-text.component.html",
  styleUrls: ["./q-card-seconary-text.component.scss"],
})
export class QCardSeconaryTextComponent {}
